import * as T from '@/core/configs/types'

export const TrackingRecordNormal = 'normal'
export const TrackingRecordDeleted = 'deleted'

export const TrackingRecordStatus = {
  TrackingRecordNormal,
  TrackingRecordDeleted
}

export const ShipmentTrackingRecord = {
  id: {
    type: T.Number,
    label: 'Tracking Record ID',
    key: 'id',
    col: 'record_id'
  },
  no: {
    type: T.String,
    label: 'Tracking No',
    key: 'no',
    col: 'record_no'
  },
  quantity: {
    type: T.Number,
    label: 'Quantity',
    key: 'quantity',
    col: 'quantity'
  },
  weight: {
    type: T.Number,
    label: 'Weight',
    key: 'weight',
    col: 'weight'
  },
  description: {
    type: T.String,
    label: 'Description',
    key: 'description',
    col: 'description'
  },
  status: {
    type: T.Enum,
    label: 'Status',
    key: 'status',
    options: Object.values(TrackingRecordStatus),
    col: 'record_status'
  },
  createdTime: {
    type: T.Time,
    label: 'Created on',
    key: 'createdTime',
    col: 'created_time'
  },
  updatedTime: {
    type: T.Time,
    label: 'Updated on',
    key: 'updatedTime',
    col: 'updated_time'
  }
}

export const TrackingRecordTableHeaders = [
  {
    ...ShipmentTrackingRecord.no,
    type: T.String,
    width: 100,
    sortable: 'custom',
    defaultSort: true
  },
  {
    ...ShipmentTrackingRecord.weight,
    type: T.String,
    width: 100
  },
  {
    ...ShipmentTrackingRecord.quantity,
    type: T.String,
    width: 100
  },
  {
    key: 'palletNos',
    label: 'Pallets',
    slotName: 'palletNos',
    type: T.SlotType,
    width: 200
  },
  {
    ...ShipmentTrackingRecord.status,
    label: 'Status',
    type: T.Tag,
    effect: 'plain',
    tagType: e => {
      switch (e) {
        default:
          return 'info'
      }
    },
    sortable: 'custom'
  },
  {
    ...ShipmentTrackingRecord.createdTime,
    width: 100,
    sortable: 'custom'
  }
]

export const TrackingRecordForm = [
  {
    ...ShipmentTrackingRecord.quantity,
    span: 1,
    type: T.NumberInput,
    value: '',
    example: '',
    validators: [T.PositiveValidator]
  },
  {
    ...ShipmentTrackingRecord.weight,
    span: 1,
    type: T.NumberInput,
    example: '',
    value: '',
    validators: [T.PositiveFloatValidator]
  },
  {
    ...ShipmentTrackingRecord.description,
    span: 1,
    example: '',
    value: '',
    validators: []
  }
]
